/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-13 10:13:59
 * @LastEditTime: 2020-08-30 15:06:17
 * @Description: 销售订单api
 */
import axios from '@/utils/axios'

export const getManyFactorySalesOrder = (payload) => {
    return axios.get('/salesOrderByManyFactory', {
        params: payload
    })
}

export const getSalesOrderById = (id) => {
    return axios.get(`/salesOrder/${id}`)
}

export const createSalesOrder = (data) => {
    return axios.post(`/salesOrder`, data)
}

export const createSalesOrderMulti = (data) => {
    return axios.post(`/sales_order_multi`, data)
}

export const updateSalesOrder = (id, data) => {
    return axios.put(`/sales_order/${id}`, data)
}

export const cancelSalesOrder = (id, data) => {
    console.log(data)
    return axios.put(`/cancel_sales_order/${id}`, data)
}

export const getSalesOrderList = (payload) => {
    return axios.get(`/sales_order`, {
        params: payload
    })
}

export const changeSalesOrderProgress = (id, data) => {
    return axios.put(`/salesOrder/progress/${id}`, data)
}

export const getSalesOrderByFactoryId = (id, payload) => {
    return axios.get(`/salesOrder/factory/${id}`, {
        params: payload
    })
}

export const salesOrderReturn = (id, data) => {
    return axios.post(`/sales_order_return/${id}`, data)
}

export const salesOrderVolByDay = (payload) => {
    return axios.get(`/sales_order_vol_by_day`, {
        params: payload
    })
}

export const salesOrderVolByMonth = (payload) => {
    return axios.get(`/sales_order_vol_by_month`, {
        params: payload
    })
}

export const getRecommendSalesOrder = (payload) => {
    return axios.get(`/sales_order_recommand`, {
        params: payload
    })
}

export const getSalesOrderProfit = (payload) => {
    return axios.get(`/sales_order_profit`, {
        params: payload
    })
}

export const calcSalesOrderProfit = (payload) => {
    return axios.post('/calc_sales_order_profit', payload)
}

export const coverSalesOrdersCalc = (payload) => {
    return axios.post('/cover_sales_order_calc', payload)
}

// export const sendww = (payload) => {
//     return axios.get(`/sendww`, {
//         params: payload
//     })
// }